import React, { useEffect } from 'react'
import { matchPath, Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { AppRoute } from 'routing/AppRoute.enum'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

import { Panel } from './Panel'
import { Blank } from './Blank'
import { TemplatesContainer } from './Templates'
import { Create } from './Create'
import { Status } from './Status'
import { Results } from './Results'
import * as S from './pulseSurveys.styles'

export const PulseSurveys = () => {
    const { prevPathname } = usePulseSurveys()

    const { pathname } = useLocation()

    const history = useHistory()

    const matchedPath = matchPath(pathname, {
        path: generateCompanyURI(AppRoute.PulseSurveyTemplates),
        exact: true,
    })

    const isPanelVisible = matchedPath === null

    useEffect(() => {
        if (!prevPathname) {
            return
        }

        if (pathname !== prevPathname) {
            history.push(prevPathname)
        }
    }, [])

    return (
        <S.PulseSurveys>
            {isPanelVisible && <Panel />}

            <S.Container>
                <Switch>
                    <Route path={generateCompanyURI(AppRoute.PulseSurvey)} exact component={Blank} />

                    <Route path={generateCompanyURI(AppRoute.PulseSurveyTemplates)} component={TemplatesContainer} />

                    <Route path={generateCompanyURI(AppRoute.PulseSurveyCreate)} component={Create} />
                    <Route path={generateCompanyURI(AppRoute.PulseSurveyStatus)} component={Status} />
                    <Route path={generateCompanyURI(AppRoute.PulseSurveyResults)} component={Results} />

                    <Redirect to={generateCompanyURI(AppRoute.PulseSurvey)} />
                </Switch>
            </S.Container>
        </S.PulseSurveys>
    )
}
